import service from '@/utils/server';
let modelPath = '/h5/visitor';

/**
 * 访客预约提交
 * @param data
 * @returns {*}
 */
export const getVisitorAppointment = data => {
    return service({
        url: modelPath+'/add',
        method: 'post',
        data
    })
};

/**
 * 安全须知
 * @param data
 * @returns {*}
 */
export const getSafetyInstructions = data => {
    return service({
        url: modelPath+'/getNotice',
        method: 'post'
    })
};



// WEBPACK FOOTER //
// ./src/page/visitor/visitorAppointment/api/index.js